/*** IMPORTS FROM imports-loader ***/
var define = false;

import FlashingGallery from './FlashingGallery'

const loadPartnersFlashingGallery = () => {
    const partnersFlashingGallery = new FlashingGallery(document.querySelector('.partners-flashing-gallery'), 3000)
    partnersFlashingGallery.init()
}

export default loadPartnersFlashingGallery




// WEBPACK FOOTER //
// ./js/partnersFlashingGallery.js